<p class="w-8 my-1" *ngIf="!isVME">
  Set a schedule for this job to control your day, keep customers informed, and cut down on ETA
  calls from Operations.
</p>

<div class="flex justify-content-between">
  <h3 class="bold-text">Task {{ taskIndex + 1 }} of {{ taskCount }}</h3>
  <p>
    <span class="bold-text">{{ task.taskDurationMinutes | minutesToHoursMinutes }}</span>
    <span class="text-gray-700"> EST. </span>
    <span class="text-cyan-500 mx-1"> / </span>
    <span class="bold-text">{{ task.taskMileage }} miles</span>
    <span class="text-gray-700"> EST. </span>
  </p>
</div>
<h3 class="my-1">Select Schedule</h3>

<schedule-selector
  (scheduleSelected)="handleScheduleSelected($event)"
  [task]="task"
  [previousTaskDropoffWindow]="previousTaskDropoffWindow"
  [isVME]="isVME"
  [isAlreadyScheduledForToday]="isAlreadyScheduledForToday"
></schedule-selector>

<div
  class="flex gap-2 mt-3 p-3 border-1 border-round-lg bg-white border-gray-400"
  *ngIf="showCarryoverNotPermittedWarning"
>
  <i class="fa fa-exclamation-triangle text-orange-500 mt-1"></i>
  <div>
    <div class="text-orange-500 font-bold">Carryover not permitted</div>
    <div class="text-gray-700">
      This schedule includes a carryover, but {{ carryoverNotPermittedReason }}.
    </div>
  </div>
</div>

<div *ngIf="task.isSupplierCarryingover">
  <h3>Select Carryover Parking</h3>
  <carryover-address-selector
    [(selectedLocation)]="task.carryoverAddress"
    [taskId]="task.id"
    [supplierId]="supplierId"
    [isVME]="isVME"
    [validationResult]="carryoverValidationResult"
    (validationResultChange)="carryoverValidationResultChange.emit($event)"
    [jobId]="jobId"
    [latestHandBackDateTime]="latestHandBackDateTime"
    (handedBack)="handedBack.emit()"
  >
  </carryover-address-selector>
</div>

<div *ngIf="taskIndex == 0">
  <h3>Select Transport Mode <span class="text-gray-700">(Optional)</span></h3>
  <transport-mode-selector
    [address]="task.pickupAddress"
    (transportModeSelected)="handleTransportModeSelected($event)"
    [selectedTransportMode]="task.supplierTransportModeToPickup"
  ></transport-mode-selector>
</div>
